/**
 * Validation for a required person-name field (first and last name on the
 * user details page and on My Account).
 *
 * PSTUDIO-4095 S23: react-hook-form's `required` rejects only an empty
 * string, so a name of spaces passed and was saved. A name is blank when
 * nothing is left after `trim()`; the value itself is not rewritten, so a
 * name with surrounding spaces is saved as typed.
 */
export const isBlankName = (value: unknown): boolean =>
  typeof value !== 'string' || value.trim() === '';

/**
 * `register` options for a required name. The message is what
 * `formState.errors.<field>.message` carries, and the field renders it.
 */
export const requiredNameRules = (message: string) => ({
  validate: (value: unknown) => !isBlankName(value) || message,
});
